<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th class="report-record" scope="col">{{$lang('ID')}}</th>
                <th class="report-record" scope="col">{{$lang('Nr zadania')}}</th>
                <th class="report-record" scope="col"
                    style="min-width: 100px">{{$lang('Data zgłoszenia')}}
                </th>
                <th class="report-record" scope="col">{{$lang('Temat')}}</th>
                <th class="report-record" scope="col">{{$lang('Status')}}</th>
                <th class="report-record" scope="col">{{$lang('Opis')}}</th>
                <th class="report-record" scope="col">{{$lang('Kryterium')}}</th>
                <th class="report-record" scope="col" v-if="with_comments">{{$lang('Komentarze')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="7" style="text-align: left" class="report-record">
                    {{$lang('Brak zgłoszeń.')}}
                </th>
            </tr>
            <tr v-else v-for="task in pagination.data">
                <td class="report-record" :data-title="$lang('ID')">
                    <a :href="'/task/' + task.id">{{task.id}}</a>
                </td>
                <td class="report-record" :data-title="$lang('Nr zadania')">
                    <a :href="jira_link + task.jira_id" target="_blank" v-if="task.jira_id"> {{task.jira_id}} </a>
                    <a v-else-if="task.ptd_id" :href="ptd_link + task.ptd_id" target="_blank">{{task.ptd_id}}</a>
                    <span v-else> - </span>
                </td>
                <td class="report-record"
                    :data-title="$lang('Data')">{{task.created_at_showable}}
                </td>
                <td class="report-record" style="text-align: left;min-width: 300px;"
                    :data-title="$lang('Temat')">{{task.subject_alternative}}
                </td>
                <td class="report-record"
                    :data-title="$lang('Status')">
                    <span :class="'badge badge-'+project_badge_prefix+task.status">{{task.statusName}}</span>
                </td>
                <td class="report-record text-justify" style="text-align: left"
                    :data-title="$lang('Opis')">{{task.description}}
                </td>
                <td class="report-record"
                    :data-title="$lang('Kryterium')">{{task.criterionName}}
                </td>
                <td class="report-record text-left" v-if="with_comments"
                    :data-title="$lang('Komentarze')">
                    <template v-if="task.comments.length > 0" v-for="(comment, index) in task.comments">
                        <div>{{$lang('Autor') + ': ' + comment.author}}</div>
                        <div class="text-break" style="white-space: pre-wrap">{{$lang('Treść') + ': ' + comment.content}}</div>
                        <div>{{$lang('Status') + ': ' + comment.statusName}}</div>
                        <div>{{$lang('Data') + ': ' + comment.time}}</div>
                        <hr class="my-2" v-if="index < task.comments.length-1">
                    </template>
                    <template v-if="!task.comments || task.comments.length === 0">
                        {{'-'}}
                    </template>
                </td>
            </tr>
            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>

        <div v-if="pagination.data.length">
            <h2 class="h4 mt-3"><strong>{{$lang('Liczba zgłoszeń:')}}</strong></h2>
            <div class="form-row mt-3">
                <div class="col-12 col-md-5">
                    <h2 class="h5 mt-4"><strong>{{$lang('według statusu')}}</strong></h2>
                    <table class=" table simple-table table-striped table-sm">
                        <thead class="thead-dark">
                        <tr>
                            <th class="report-record" scope="col"
                                style="text-align: left">{{$lang('Status')}}
                            </th>
                            <th class="report-record" scope="col">{{$lang('Liczba zgłoszeń')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(amount, name) in statuses" v-if="amount>0">
                            <td class="report-record" style="text-align: left"
                                :data-title="$lang('Status')">{{name}}
                            </td>
                            <td class="report-record"
                                :data-title="$lang('Ilość')">{{amount}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-12 offset-md-2 col-md-5">
                    <h2 class="h5 mt-4"><strong>{{$lang('według kryterium')}}</strong></h2>
                    <table class=" table simple-table table-striped table-sm">
                        <thead class="thead-dark">
                        <tr>
                            <th class="report-record" scope="col"
                                style="text-align: left">{{$lang('Kryterium')}}
                            </th>
                            <th class="report-record" scope="col">{{$lang('Liczba zgłoszeń')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(amount, name) in criteria" v-if="amount>0">
                            <td class="report-record" style="text-align: left"
                                :data-title="$lang('Kryterium')">{{name}}
                            </td>
                            <td class="report-record"
                                :data-title="$lang('Ilość')">{{amount}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tasks-by-client-table',
        props: {
            pagination: Object,
            statuses: Object | Array,
            criteria: Object | Array,
            jira_link: String,
            ptd_link: String,
            project_badge_prefix: String,
            with_comments: Boolean
        },
    }
</script>
